import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AssetManagement, AssetSourceConfigurationItem } from '@aptsi-types';
import { environment } from '@env';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorHandlingService } from 'src/app/shared/errorHandling/errorHandling.service';
import { API_ENDPOINTS } from 'src/app/features/asset-management/asset-management-api-endpoints';


@Injectable({
    providedIn: 'root'
})
export class DataAssetConfigurationService {
    private readonly dataAssetConfigUrl = environment.apiUrl;

    constructor(private http: HttpClient, private errorHandlingService: ErrorHandlingService) { }


    FetchDataAssetConfigurations(
        currentPage: number
    ): Observable<AssetManagement[]> {
        return this.http
            .post<AssetManagement[]>(
                `${this.dataAssetConfigUrl}${API_ENDPOINTS.DATAASSETCONFIGURATION.FETCH_DATA_ASSET_CONFIGURATIONS}`,
                { currentPage }
            )
            .pipe(
                map((response) => response),
                catchError((error) => this.errorHandlingService.handleError(error))
            );
    }

    FetchDataAssetConfigurationsSearch(
        currentPage: number,
        searchText: String,
        filterByHeader: String
    ): Observable<AssetManagement[]> {
        return this.http
            .post<AssetManagement[]>(
                `${this.dataAssetConfigUrl}${API_ENDPOINTS.DATAASSETCONFIGURATION.FETCH_DATA_ASSET_CONFIGURATIONS_SEARCH}`,
                { currentPage, searchText, filterByHeader }
            )
            .pipe(
                map((response) => response),
                catchError((error) => this.errorHandlingService.handleError(error))
            );
    }

    FetchDataAssetConfigurationById(dataAssetId: string): Observable<AssetManagement[]> {
        return this.http
            .post<AssetManagement[]>(
                `${this.dataAssetConfigUrl}${API_ENDPOINTS.DATAASSETCONFIGURATION.FETCH_DATA_ASSET_CONFIGURATION_BY_ID}`,
                { dataAssetId }
            )
            .pipe(
                map((response) => response),
                catchError((error) => this.errorHandlingService.handleError(error))
            );
    }




    ConfigureDataAssetForConfiguredStatus(
        dataAssetId: string,
        riskValue: string,
        businessValue: string,
        dataClassificationIds: string[],
        assetRiskLevelId: string,
        dataAssetTypeIds: string[],
        regimeIds: string[],
        configuredBy: string,
        configuredByKeycloakId: string
    ) {
        return this.http
            .post<AssetManagement>(
                `${this.dataAssetConfigUrl}${API_ENDPOINTS.DATAASSETCONFIGURATION.CONFIGURE_DATA_ASSET_FOR_CONFIGURED_STATUS}`,
                {
                    dataAssetId,
                    riskValue,
                    businessValue,
                    dataClassificationIds,
                    assetRiskLevelId,
                    dataAssetTypeIds,
                    regimeIds,
                    configuredBy,
                    configuredByKeycloakId
                }
            )
            .pipe(
                map((response) => response),
                catchError((error) => this.errorHandlingService.handleError(error))
            );
    }




    ConfigureDataAssetForNotConfiguredStatus(
        dataAssetId: string,
        riskValue: string,
        businessValue: string,
        dataClassificationIds: string[],
        assetRiskLevelId: string,
        dataAssetTypeIds: string[],
        regimeIds: string[],
        configuredBy: string,
        configuredByKeycloakId: string
    ) {
        return this.http
            .post<AssetManagement>(
                `${this.dataAssetConfigUrl}${API_ENDPOINTS.DATAASSETCONFIGURATION.CONFIGURE_DATA_ASSET_FOR_NOT_CONFIGURED_STATUS}`,
                {
                    dataAssetId,
                    riskValue,
                    businessValue,
                    dataClassificationIds,
                    assetRiskLevelId,
                    dataAssetTypeIds,
                    regimeIds,
                    configuredBy,
                    configuredByKeycloakId
                }
            )
            .pipe(
                map((response) => response),
                catchError((error) => this.errorHandlingService.handleError(error))
            );
    }


    CreateConfiguredDropdownsRegime(name: string, organizationId: string) {
        return this.http
            .post<AssetManagement>(
                `${this.dataAssetConfigUrl}${API_ENDPOINTS.DATAASSETCONFIGURATION.CREATE_CONFIGURED_DROPDOWNS_REGIME}`,
                {
                    name,
                    organizationId
                }
            )
            .pipe(
                map((response) => response),
                catchError((error) => this.errorHandlingService.handleError(error))
            );
    }

    FetchConfiguredDropdownsRegime(organizationId: string) {
        return this.http
            .post<AssetManagement>(
                `${this.dataAssetConfigUrl}${API_ENDPOINTS.DATAASSETCONFIGURATION.FETCH_CONFIGURED_DROPDOWNS_REGIME}`,
                {
                    organizationId
                }
            )
            .pipe(
                map((response) => response),
                catchError((error) => this.errorHandlingService.handleError(error))
            );
    }

    CreateConfiguredDropdownsDataClassification(name: string, organizationId: string) {
        return this.http
            .post<AssetManagement>(
                `${this.dataAssetConfigUrl}${API_ENDPOINTS.DATAASSETCONFIGURATION.CREATE_CONFIGURED_DROPDOWNS_DATA_CLASSIFICATION}`,
                {
                    name,
                    organizationId
                }
            )
            .pipe(
                map((response) => response),
                catchError((error) => this.errorHandlingService.handleError(error))
            );
    }

    FetchConfiguredDropdownsDataClassification(organizationId: string) {
        return this.http
            .post<AssetManagement>(
                `${this.dataAssetConfigUrl}${API_ENDPOINTS.DATAASSETCONFIGURATION.FETCH_CONFIGURED_DROPDOWNS_DATA_CLASSIFICATION}`,
                {
                    organizationId
                }
            )
            .pipe(
                map((response) => response),
                catchError((error) => this.errorHandlingService.handleError(error))
            );
    }



    CreateConfiguredDropdownsDataAssetType(name: string, organizationId: string) {
        return this.http
            .post<AssetManagement>(
                `${this.dataAssetConfigUrl}${API_ENDPOINTS.DATAASSETCONFIGURATION.CREATE_CONFIGURED_DROPDOWNS_DATA_ASSET_TYPE}`,
                {
                    name,
                    organizationId
                }
            )
            .pipe(
                map((response) => response),
                catchError((error) => this.errorHandlingService.handleError(error))
            );
    }

    FetchConfiguredDropdownsDataAssetType( organizationId: string) {
        return this.http
            .post<AssetManagement>(
                `${this.dataAssetConfigUrl}${API_ENDPOINTS.DATAASSETCONFIGURATION.FETCH_CONFIGURED_DROPDOWNS_DATA_ASSET_TYPE}`,
                {
                    organizationId
                }
            )
            .pipe(
                map((response) => response),
                catchError((error) => this.errorHandlingService.handleError(error))
            );
    }


    CreateConfiguredDropdownsAssetRiskLevel(name: string, organizationId: string) {
        return this.http
            .post<AssetManagement>(
                `${this.dataAssetConfigUrl}${API_ENDPOINTS.DATAASSETCONFIGURATION.CREATE_CONFIGURED_DROPDOWNS_ASSET_RISK_LEVEL}`,
                {
                    name,
                    organizationId
                }
            )
            .pipe(
                map((response) => response),
                catchError((error) => this.errorHandlingService.handleError(error))
            );
    }

    FetchConfiguredDropdownsAssetRiskLevel( organizationId: string) {
        return this.http
            .post<AssetManagement>(
                `${this.dataAssetConfigUrl}${API_ENDPOINTS.DATAASSETCONFIGURATION.FETCH_CONFIGURED_DROPDOWNS_ASSET_RISK_LEVEL}`,
                {
                    organizationId
                }
            )
            .pipe(
                map((response) => response),
                catchError((error) => this.errorHandlingService.handleError(error))
            );
    }


} 